import { ReactNode } from 'react'
import styles from './index.module.sass'

export const RegisterCard = ({ title, image, content, actions }: IArgs) => {
    return (
        <div className={styles.root}>
            <div className={styles.title}>{title}</div>
            <img className={styles.image} alt="img" src={image}/>
            <div className={styles.content}>{content}</div>
            <div className={styles.actions}>{actions}</div>
        </div>
    )
}

interface IArgs {
    title: string,
    image: string,
    content: ReactNode,
    actions: ReactNode,
}